module.exports = __webpack_public_path__ + "static/media/_MIC2292.thumbnail.b3b75091.png";